import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GobiernoUser, Rol, User } from '../interfaces/user.interface';
import { Company } from '../interfaces/compani.inteface';

export interface AsignarRolRequest {
    usuarioId: string;
    rolId: string;
    estado: boolean;
    fechaInicio?: string | null;
    fechaFin?: string;
}

export interface MotivoEstadoUsuario {
    id: number;
    nombre: string;
}

@Injectable({
    providedIn: 'root',
})
export class UserServiceService {
    private readonly _apiUrl = environment.apiSiriUrl;

    public constructor(private http: HttpClient) {}

    public async GetUsers(url: string): Promise<User[]> {
        const apiUrl = `${environment.apiSiriUrl}${url}`;
        return firstValueFrom(this.http.get<User[]>(apiUrl));
    }

    public async GetGobiernoUsers(url: string): Promise<GobiernoUser[]> {
        const apiUrl = `${environment.apiSiriUrl}${url}`;
        return firstValueFrom(this.http.get<GobiernoUser[]>(apiUrl));
    }

    public async getUserCompanys(): Promise<
        { representante: User; empresas: Company[] }[]
    > {
        const representantes = await firstValueFrom(
            this.http.get<User[]>(
                `${environment.apiSiriUrl}representante-agente-vigilado`
            )
        );
        const empresas = await firstValueFrom(
            this.http.get<Company[]>(`${environment.apiSiriUrl}agente-vigilado`)
        );
        const representanteConEmpresas: {
            representante: User;
            empresas: Company[];
        }[] = [];
        representantes.forEach((representante) => {
            const empresasDelRepresentante = empresas.filter(
                (empresa) =>
                    empresa.representante_agente_vigilado_id ===
                    representante.id
            );
            representanteConEmpresas.push({
                representante,
                empresas: empresasDelRepresentante,
            });
        });
        return representanteConEmpresas;
    }

    public async PutUser(url: string): Promise<unknown> {
        const apiUrl = `${environment.apiSiriUrl}${url}`;
        return firstValueFrom(this.http.patch(apiUrl, {}));
    }

    public getRoles(): Observable<Rol[]> {
        return this.http.get<Rol[]>(`${this._apiUrl}permisos/roles`);
    }

    public asignarRol(payload: AsignarRolRequest): Observable<unknown> {
        return this.http.post(`${this._apiUrl}permisos/asignar-rol`, payload);
    }

    public async getMotivosActivacionInactivacionUsuario(
        tipo: 'activacion' | 'inactivacion'
    ): Promise<MotivoEstadoUsuario[]> {
        const url = `${this._apiUrl}usuario/motivos/${tipo}`;
        return firstValueFrom(this.http.get<MotivoEstadoUsuario[]>(url));
    }

    public async postActualizarEstadoUsuario(
        body: {
            usuarioID: number;
            estado: boolean;
            motivoId?: number | null;
            otroMotivo?: string | null;
        },
        url = `${this._apiUrl}usuario/cambiar-estado-usuario`
    ): Promise<unknown> {
        return firstValueFrom(this.http.post(url, body));
    }
}
